<ng-container>
  <p *ngIf="(loaderService.isLoading | async)" style="text-align: center;">Merci de bien vouloir patienter</p>
  <div #carousel class="owl-carousel-spe owl-theme">
    <div>
      <app-advertisement></app-advertisement>
    </div>
    <div>
      <app-advertisement></app-advertisement>
    </div>
    <div>
      <app-advertisement></app-advertisement>
    </div>
  </div>
</ng-container>